import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom';
import { IsTokenExpired } from '../../helpers/lib/jwt';
import React, { useEffect, useState } from 'react';
import { getUser } from '../../helpers/lib/axios';
import Section from '../Section';
import BannerSectionStyle3 from '../Section/BannerSection/BannerSectionStyle3';

const Profile = () => {
    const navigate = useNavigate()

    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const token = Cookies.get('noohraToken')
        if (!token) {
            navigate('/signup')
            return;
        }
        if (IsTokenExpired(token)) {
            Cookies.remove("noohraToken");
            setUser(null)
            navigate('/signup')
            return;
        } else {
            setIsLoading(true)
            getUser().then(user => {
                setUser(user?.data);
            }).catch(err => console.log(err))
                .finally(() => setIsLoading(false))
        }
    }, [navigate])

    return (<>
        <BannerSectionStyle3
            bgUrl="/images/about/banner_bg.svg"
            imgUrl="/images/about/banner_img.png"
            title="Profile"
            subTitle="User information"
        />
        <Section
            topMd={170}
            topLg={150}
            topXl={110}
            bottomMd={200}
            bottomLg={150}
            bottomXl={110}
        >
            <div className="max-w-sm lg:max-w-lg mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
                <div className="bg-gray-100 py-4">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-28 h-28 mx-auto rounded-full border-[4px] border-white p-2">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 14c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zM4 20c0-4.418 3.582-8 8-8s8 3.582 8 8H4z" />
                    </svg>

                </div>
                {isLoading ? (
                    // Show a loading indicator or skeleton rows when loading
                    <div className='flex justify-center items-center'>
                        <div className="px-6 py-4 text-center">
                            <div className="flex justify-center items-center">
                                <svg
                                    className="animate-spin h-8 w-8 text-gray-500"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    ></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8v8H4z"
                                    ></path>
                                </svg>
                                <span className="ml-4 text-gray-500">Loading...</span>
                            </div>
                        </div>
                    </div>
                ) : <div className="p-6">
                    <h2 className="text-xl font-semibold text-gray-800">Name: {user?.firstName + ' ' + user?.lastName}</h2>
                    <p className="text-gray-600">Email: {user?.email}</p>
                    <p className="mt-4 text-gray-500">Gender: {user?.gender || "No gender available."}</p>
                </div>}
            </div>
        </Section>
    </>);
}

export default Profile;